import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';
import { Col, Card, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import { destroy } from 'redux-form';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import {
  THEMES_SUCCESS,
  THEMES_FAILED,
  themeClearState as themeClearStateAction,
  getAsyncData as getAsyncDataAction,
  getTheme as getThemeAction,
} from '../../../../redux/actions/themesAction';
import WizardFormOne from './WizardFormOne';
import WizardFormTwo from './WizardFormTwo';
import WizardFormThree from './WizardFormThree';
import WizardFormFour from './WizardFormFour';
import WizardFormFive from './WizardFormFive';
import WizardFormSix from './WizardFormSix';
import WizardFormSeven from './WizardFormSeven';
import WizardFormEight from './WizardFormEight';
import WizardFormNine from './WizardFormNine';
import { FullWideNotification } from '../../../../shared/components/Notification';

class WizardForm extends PureComponent {
  static propTypes = {
    initialValues: PropTypes.objectOf(PropTypes.any).isRequired,
    history: PropTypes.objectOf(PropTypes.any).isRequired,
    asyncData: PropTypes.objectOf(PropTypes.any).isRequired,
    asyncStatus: PropTypes.string.isRequired,
    submitStatus: PropTypes.string.isRequired,
    loadStatus: PropTypes.string.isRequired,
    showNotification: PropTypes.func.isRequired,
    getAsyncData: PropTypes.func.isRequired,
    themeClearState: PropTypes.func.isRequired,
    getTheme: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.state = {
      page: 1,
    };
  }

  componentDidMount() {
    const {
      // eslint-disable-next-line react/prop-types
      getAsyncData,
      getTheme,
      // eslint-disable-next-line react/prop-types
      match,
      // eslint-disable-next-line react/prop-types
      reinitializeReduxForm,
    } = this.props;
    // eslint-disable-next-line react/prop-types
    const { themeId } = match.params;

    reinitializeReduxForm();

    getAsyncData();
    getTheme(themeId);
  }

  componentWillReceiveProps(nextProps) {
    const { submitStatus, loadStatus, history } = nextProps;

    if (loadStatus === THEMES_FAILED) {
      history.push('/404');
    }

    if (submitStatus === THEMES_SUCCESS) {
      history.push('/themes');
    } else if (submitStatus === THEMES_FAILED) {
      this.show('danger', 'Произошла непредвиденная ошибка. Обратитесь к разработчикам.');
    }
  }

  componentWillUnmount() {
    const { themeClearState } = this.props;
    themeClearState();
  }

  show = (color, message) => {
    const { showNotification } = this.props;
    return showNotification({
      notification: <FullWideNotification color={color} message={message} />,
      position: 'full',
    });
  };

  nextPage = () => {
    this.setState((prevState) => ({ page: prevState.page + 1 }));
  };

  previousPage = () => {
    this.setState((prevState) => ({ page: prevState.page - 1 }));
  };

  render() {
    const { asyncData, asyncStatus, loadStatus, showNotification, initialValues } = this.props;
    const { page } = this.state;

    return (
      <Row>
        <Col md={12} lg={12}>
          <Card>
            <div className="wizard">
              <div className="wizard__steps">
                <div className={`wizard__step${page === 1 ? ' wizard__step--active' : ''}`}>
                  <p>Шаг 1</p>
                </div>
                <div className={`wizard__step${page === 2 ? ' wizard__step--active' : ''}`}>
                  <p>Шаг 2</p>
                </div>
                <div className={`wizard__step${page === 3 ? ' wizard__step--active' : ''}`}>
                  <p>Шаг 3</p>
                </div>
                <div className={`wizard__step${page === 4 ? ' wizard__step--active' : ''}`}>
                  <p>Шаг 4</p>
                </div>
                <div className={`wizard__step${page === 5 ? ' wizard__step--active' : ''}`}>
                  <p>Шаг 5</p>
                </div>
                <div className={`wizard__step${page === 6 ? ' wizard__step--active' : ''}`}>
                  <p>Шаг 6</p>
                </div>
                <div className={`wizard__step${page === 7 ? ' wizard__step--active' : ''}`}>
                  <p>Шаг 7</p>
                </div>
                <div className={`wizard__step${page === 8 ? ' wizard__step--active' : ''}`}>
                  <p>Шаг 8</p>
                </div>
                <div className={`wizard__step${page === 9 ? ' wizard__step--active' : ''}`}>
                  <p>Шаг 9</p>
                </div>
              </div>
              {asyncStatus === THEMES_SUCCESS && loadStatus === THEMES_SUCCESS && (
                <div className="wizard__form-wrapper">
                  {page === 1 && <WizardFormOne onSubmit={this.nextPage} initialValues={initialValues} />}
                  {page === 2 && <WizardFormTwo previousPage={this.previousPage} onSubmit={this.nextPage} />}
                  {page === 3 && (
                    <WizardFormThree previousPage={this.previousPage} onSubmit={this.nextPage} asyncData={asyncData} />
                  )}
                  {page === 4 && (
                    <WizardFormFour previousPage={this.previousPage} onSubmit={this.nextPage} asyncData={asyncData} />
                  )}
                  {page === 5 && <WizardFormFive previousPage={this.previousPage} onSubmit={this.nextPage} />}
                  {page === 6 && <WizardFormSix previousPage={this.previousPage} onSubmit={this.nextPage} />}
                  {page === 7 && <WizardFormSeven previousPage={this.previousPage} onSubmit={this.nextPage} />}
                  {page === 8 && (
                    <WizardFormEight
                      previousPage={this.previousPage}
                      onSubmit={this.nextPage}
                      showNotification={showNotification}
                    />
                  )}
                  {page === 9 && <WizardFormNine previousPage={this.previousPage} />}
                </div>
              )}
            </div>
          </Card>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({
  initialValues: state.themes.active,
  asyncData: state.themes.asyncData,
  asyncStatus: state.themes.asyncStatus,
  submitStatus: state.themes.submitStatus,
  loadStatus: state.themes.loadActiveStatus,
});

const mapDispatchToProps = (dispatch) => ({
  getTheme: (themeId) => dispatch(getThemeAction(themeId)),
  getAsyncData: () => dispatch(getAsyncDataAction()),
  themeClearState: () => dispatch(themeClearStateAction()),
  reinitializeReduxForm: () => dispatch(destroy('themes_edit_form')),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(withRouter(WizardForm)));
